var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{staticStyle:{"height":"100vh","width":"100%"},attrs:{"name":"my-iframe","id":"my-iframe","src":"https://www.720yun.com/t/7fakih7hzqe?scene_id=123155274","frameborder":"0","scrolling":"no"}})])
}]

export { render, staticRenderFns }